import axios from 'axios'
import { api, baseURL } from './client'

export { api }

export interface User {
  id: string
  username: string
  email: string
  first_name: string
  last_name: string
  role: 'ADMIN' | 'SUPERVISOR' | 'CUSTOMER' | 'EMPLOYEE'
  is_active: boolean
  date_joined: string
  last_login: string | null
  created_by: string | null
  owner_id: string | null
  created_by_name: string
  owner_name: string
  phone_number?: string
  location?: string
}

export interface UserForm {
  username: string
  email: string
  first_name: string
  last_name: string
  role: 'ADMIN' | 'SUPERVISOR' | 'CUSTOMER' | 'EMPLOYEE'
  password?: string
  confirmPassword?: string
  is_active?: boolean
  phone_number?: string
  location?: string
}

export const authService = {
  async login(email: string, password: string) {
    const response = await api.post('auth/login/', { email, password })
    return response.data
  },
  async register(userData: {
    username: string
    email: string
    password: string
    confirmPassword: string
    first_name: string
    last_name: string
  }) {
    const response = await axios.post(`${baseURL}auth/register/`, userData)
    return response.data
  },
  async logout(refreshToken: string) {
    return await api.post('auth/logout/', {
      refresh_token: refreshToken,
    })
  },
  async getUserProfile() {
    const response = await api.get('auth/profile/')
    return response.data
  },
  async refreshToken(refresh: string) {
    return axios.post(`${baseURL}token/refresh/`, { refresh })
  },
  async createUser(userData: UserForm) {
    const response = await api.post('auth/create-supervisor/', userData)
    return response.data
  },
  async getUsers(role?: string): Promise<User[]> {
    const params = role ? { role } : {}
    const response = await api.get('auth/users/', { params })
    return response.data
  },
  async updateUser(id: string, userData: Partial<UserForm>) {
    const response = await api.put(`auth/users/${id}/`, userData)
    return response.data
  },
  async deleteUser(id: string) {
    const response = await api.delete(`auth/users/${id}/delete/`)
    return response.data
  },
  async toggleUserActive(id: string, is_active: boolean): Promise<void> {
    await api.patch(`auth/users/${id}/toggle-active/`, { is_active })
  },
  async updateProfile(userData: Partial<UserForm>) {
    const response = await api.put('auth/profile/', userData)
    return response.data
  },
  async requestPasswordReset(email: string) {
    const response = await api.post('auth/password-reset/', { email })
    return response.data
  },
  async confirmPasswordReset(data: { uid: string; token: string; password: string; confirmPassword: string }) {
    const response = await api.post('auth/password-reset-confirm/', data)
    return response.data
  },
}
